const APP_NAME = "Grigora";
const WEBCLIP_URL = "https://cdn.grigora.co/defaults/img/webclip.png";
const SUPPORT_EMAIL = "hello@grigora.co";
const BASE_APP_DOMAIN = "build.grigora.co";
const DEFAULT_LOCATION = "Bengaluru, India";
const PUBLISHED_WEBSITE_DOMAIN = "grigora.app";

export {
  APP_NAME,
  WEBCLIP_URL,
  SUPPORT_EMAIL,
  BASE_APP_DOMAIN,
  DEFAULT_LOCATION,
  PUBLISHED_WEBSITE_DOMAIN,
};
